import { render, staticRenderFns } from "./turnTable.vue?vue&type=template&id=2442f8c2&scoped=true"
import script from "./turnTable.vue?vue&type=script&lang=js"
export * from "./turnTable.vue?vue&type=script&lang=js"
import style0 from "./turnTable.vue?vue&type=style&index=0&id=2442f8c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2442f8c2",
  null
  
)

export default component.exports